import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { IlButton, IlIcon } from 'il-framework-component';
import classNames from 'classnames';
import { SwitchIdentityList } from '../SwitchIdentityList/SwitchIdentityList.js';

var BASE_CSS = 'il-header-switch-identity-modal';
function SwitchIdentityModal(_ref) {
  var showSwitchIdentityModal = _ref.showSwitchIdentityModal,
    modalClassName = _ref.modalClassName,
    listIdentities = _ref.listIdentities,
    applicationId = _ref.applicationId,
    onCloseCallback = _ref.onCloseCallback,
    hostUrl = _ref.hostUrl;
  var modalRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    closeSwitchIdentityModal = _useState2[0],
    setCloseSwitchIdentityModal = _useState2[1];
  var closeModal = function closeModal() {
    setCloseSwitchIdentityModal(true);
    onCloseCallback();
  };
  var handleClickOutside = function handleClickOutside(event) {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setCloseSwitchIdentityModal(true);
      onCloseCallback();
    }
  };
  useEffect(function () {
    document.addEventListener('click', handleClickOutside, false);
    return function () {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-labelledby": "".concat(BASE_CSS, "__title"),
    role: "dialog",
    "data-testid": "".concat(BASE_CSS, "__title"),
    ref: modalRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames("".concat(BASE_CSS), _defineProperty({}, "".concat(BASE_CSS, "__is-open"), showSwitchIdentityModal), _defineProperty({}, "".concat(BASE_CSS, "__close"), closeSwitchIdentityModal), modalClassName)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(BASE_CSS, "__title-wrapper")
  }, /*#__PURE__*/React__default.createElement("span", {
    id: "".concat(BASE_CSS, "__title"),
    className: "".concat(BASE_CSS, "__title"),
    role: "heading",
    "aria-level": "1"
  }, "Switch Identity"), /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(BASE_CSS, "__close")
  }, /*#__PURE__*/React__default.createElement(IlButton, {
    className: "".concat(BASE_CSS, "__closeBtn"),
    onClick: closeModal,
    type: "button",
    "aria-label": "Close",
    "data-testid": "".concat(BASE_CSS, "__closeBtn"),
    kind: "ghost"
  }, /*#__PURE__*/React__default.createElement(IlIcon, {
    name: "close-v1"
  })))), /*#__PURE__*/React__default.createElement(SwitchIdentityList, {
    linkedIdentitiesList: listIdentities,
    applicationId: applicationId,
    hostUrl: hostUrl
  })));
}
SwitchIdentityModal.propTypes = {
  modalClassName: PropTypes.string,
  showSwitchIdentityModal: PropTypes.bool.isRequired,
  listIdentities: PropTypes.array,
  applicationId: PropTypes.string,
  onCloseCallback: PropTypes.func,
  hostUrl: PropTypes.string
};
SwitchIdentityModal.defaultProps = {
  modalClassName: '',
  listIdentities: [],
  applicationId: ''
};

export { SwitchIdentityModal };
